<div class="nav-breadcrumbs">
    <app-nav-breadcrumb
        *ngFor="let crumb of crumbs"
        [navigable]="crumb.navigable"
        [text]="crumb.text"
        [routerLink]="crumb.routerLink"
    ></app-nav-breadcrumb>
</div>
